/** Straight-line distance in km between two [lat, lng] points. */
export function haversineKm(a, b) {
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(b[0] - a[0]);
  const dLng = toRad(b[1] - a[1]);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a[0])) * Math.cos(toRad(b[0])) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
}

function coordOf(order) {
  const lat = parseFloat(order?.deliveryLatitude);
  const lng = parseFloat(order?.deliveryLongitude);
  return Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null;
}

/**
 * Cheapest place to slot `candidate` into the route, by straight-line detour.
 * Position k means "insert before stop k" (0 = first stop, stops.length = after the last one),
 * matching the PATCH /routes insertPosition. Returns null when the candidate has no pin.
 */
export function bestInsertion(hub, stops, candidate, roundTrip) {
  const p = coordOf(candidate);
  if (!p) return null;
  const n = stops.length;
  const pointAt = (i) => (i < 0 ? hub : i >= n ? (roundTrip ? hub : null) : coordOf(stops[i]));

  let best = null;
  for (let k = 0; k <= n; k++) {
    const a = pointAt(k - 1);
    const b = pointAt(k);
    // A stop without a pin can't be measured: skip the slots next to it rather than mistake it for the route end.
    if (!a || (!b && k < n)) continue;
    const detour = b ? haversineKm(a, p) + haversineKm(p, b) - haversineKm(a, b) : haversineKm(a, p);
    if (best == null || detour < best.detourKm) best = { position: k, detourKm: Math.max(0, detour) };
  }
  return best;
}

/** Same rule as the backend: direct-delivery orders cannot share a route with other stops. */
export function canJoinRoute(order, routeOrders) {
  if (routeOrders.length === 0) return true;
  if (order.directDeliveryOnly) return false;
  return !routeOrders.some((o) => o.directDeliveryOnly);
}
